
                import { Component } from "/app/packages/open-source/blognami/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/open-source/blognami/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/open-source/@blognami/main/lib/views/_tabs.js";
                const hash = "NTi2OLfWiN";
                Component.include(createDecoratorsInclude(hash, decorators));
            